import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { TerrainIcon } from './TerrainIcon';
import { TERRAIN_TYPES, TERRAIN_LABELS, TerrainType } from '@/lib/types/core/terrain';

interface TerrainFilterProps {
  selected: TerrainType[];
  onChange: (selected: TerrainType[]) => void;
}

export const TerrainFilter: React.FC<TerrainFilterProps> = ({
  selected,
  onChange,
}) => {
  const [expanded, setExpanded] = useState(false);

  const toggleTerrain = (terrain: TerrainType) => {
    onChange(
      selected.includes(terrain)
        ? selected.filter(t => t !== terrain)
        : [...selected, terrain]
    );
  };

  return (
    <div className="border-b border-adv-darkGray pb-4">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center justify-between w-full text-left"
      >
        <span className="text-sm font-medium text-adv-lightGray">
          Terrain
        </span>
        {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </button>

      {expanded && (
        <div className="mt-2 space-y-1">
          {TERRAIN_TYPES.map(terrain => (
            <label
              key={terrain}
              className="flex items-center gap-2 cursor-pointer p-1 hover:bg-adv-darkGray rounded"
            >
              <input
                type="checkbox"
                checked={selected.includes(terrain)}
                onChange={() => toggleTerrain(terrain)}
                className="rounded border-adv-darkGray"
              />
              <TerrainIcon terrain={terrain} size={16} />
              <span className="text-sm text-adv-lightGray">
                {TERRAIN_LABELS[terrain]}
              </span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};
